module.exports = __webpack_public_path__ + "static/atelier_pc-9b6316b63f6acf134e169a218c110d32.png";